var map = {
	"./dice-1.png": 7876,
	"./dice-2.png": 21439,
	"./dice-3.png": 43350,
	"./dice-4.png": 33961,
	"./dice-5.png": 62784,
	"./dice-6.png": 17819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60452;